import { API } from "./api.environment";

export const environment = {
    production: true,

    ruta_traducciones: '/core/assets/i18n/',


    ENTORNO: location.origin + '/',
    SessionService: API
};
